module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-news-slideshow-mobile u-relative u-viewport-fit-w u-overflow-h",
    on: {
      "touchstart": _vm.onTouchDown,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('div', {
    staticClass: "c-news-slideshow-mobile__items-container u-relative u-marg-x-auto u-w9of10 u-fit-h"
  }, _vm._l((_vm.news), function(n, index) {
    return _c('div', {
      staticClass: "c-news-slideshow-mobile__items-container__item js-slideshow-item u-absolute u-fit-w u-fit-h u-pad-a-xs u-pad-a-xxs@sm u-cursor-pointer",
      class: ['c-news-slideshow-mobile__items-container__item--' + index],
      on: {
        "click": function($event) {
          _vm.changeActiveIndexTo(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-news-slideshow-mobile__items-container__item__cover-container u-relative u-overflow-h"
    }, [_c('div', {
      staticClass: "c-news-slideshow-mobile__items-container__item__cover-container__cover u-absolute u-pos-tl u-fit u-index--1 u-cover",
      style: ({
        backgroundImage: 'url(' + n.cover + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "c-news-slideshow-mobile__items-container__item__cover-container__filter u-absolute u-pos-bl u-index--2 u-fit u-bg--black u-opacity--5 u-opacity--2@sm"
    }), _vm._v(" "), _c('div', {
      staticClass: "c-news-slideshow-mobile__items-container__item__cover-container__overlay u-absolute u-pos-bl u-index--2 u-fit-w"
    })]), _vm._v(" "), _c('app-text-mask', {
      staticClass: "c-news-slideshow-mobile__items-container__item__title u-w2of3 u-w5of6@lg t-text--bold t-text--xl u-uppercase u-absolute u-pos-bl u-marg-l-lg u-align-left u-index--5 u-marg-l-xxs@md u-marg-l-xs@lg t-text--lg@xs",
      attrs: {
        "text": _vm._shorten(n.title, 45),
        "type": "h2",
        "class-default": "u-color--white",
        "class-over": "u-color--red-pure"
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b94d2a8"}!./src/scripts/components/app-news-slideshow-mobile/template.html
// module id = 912
// module chunks = 0